import BaseEvent from './BaseEvent.js';

class SetLayoutEvent extends BaseEvent {
  handle(msg) {
    this.context._api.setLayout(msg.params);
  }
}

export default SetLayoutEvent;
